type FormatCandidateParamsData = { data: Record<string, any>; offerIds: null | number[] };

export function formatCandidateParams<T extends FormatCandidateParamsData, U extends true>(
  data: T,
  formData: U,
): FormData;
export function formatCandidateParams<T extends FormatCandidateParamsData, U extends false>(
  data: T,
  formData: U,
): { candidate: T['data']; offers: T['offerIds'] };
export function formatCandidateParams<T extends FormatCandidateParamsData, U extends boolean>(
  data: T,
  formData: U,
): FormData | { candidate: T['data'] };
export function formatCandidateParams<T extends FormatCandidateParamsData>(
  { data, offerIds = null }: T,
  formData = false,
): FormData | { candidate: T['data']; offers: T['offerIds'] } {
  let body: FormData | { candidate: T['data']; offers: T['offerIds'] };
  if (formData) {
    body = new FormData();
    for (const key in data) {
      const value = data[key];
      if (value != null) {
        if (Array.isArray(value)) {
          for (let i = 0; i < value.length; i++) {
            const item = <any>value[i];
            if (key === 'customFields') {
              body.append(`candidate[${key}][${i}][label]`, item.label);
              for (let j = 0; j < item.values.length; j++) {
                const field = item.values[j];
                body.append(`candidate[${key}][${i}][values][]`, field);
              }
            } else {
              body.append(`candidate[${key}][]`, item);
            }
          }
        } else {
          body.append(`candidate[${key}]`, value);
        }
      }
    }
    if (offerIds != null) {
      for (let k = 0; k < offerIds.length; k++) {
        const id = <string>(<unknown>offerIds[k]);
        body.append('offers[]', id);
      }
    }
  } else {
    body = { candidate: data, offers: offerIds };
  }
  return body;
}
